import { useState, useEffect } from 'react';
import { useGlobal } from './global';

export const useProxyStatus = () => {
  const { fox } = useGlobal();
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!fox) return;

    setLoading(true);
    fox.proxy.status().then((s) => {
      setStatus(s);
      setLoading(false);
    });
  }, [fox]);
  
  return { loading, status };
}
